import { useQuery } from 'react-fetching-library';

export default function useBankReports() {
  const result = useQuery({
    method: 'GET',
    endpoint: 'https://rupiahtoken-content.herokuapp.com/bankreports?_sort=Date:DESC',
    skipToken: true
  });
  return result;
}
